import React from "react";
import { FooterLeft } from "./components/footerLeft";
import { FooterCenter } from "./components/footerCenter";
import { FooterRight } from "./components/footerRight";

const Footer: React.FC = () => {
  return (
    <footer className="relative z-[2] pt-12 px-6 bg-white md:px-10 lg:px-[6%]">
      <hr />
      <div className="mx-auto mt-[8vh]">
        <div className="flex flex-col lg:flex-row justify-between gap-12 lg:gap-0 items-start">
          {/* Left Section */}
          <div className="w-full lg:w-1/3 lg:h-full flex justify-start">
            <FooterLeft />
          </div>

          {/* Center Section - with divider */}
          <div className="w-full lg:w-1/3 flex justify-start lg:justify-center relative">
            <div className="hidden lg:block absolute left-0 top-[10%] h-[80%] w-px bg-gray-100"></div>
            <FooterCenter />
          </div>

          {/* Right Section */}
          <div className="w-full lg:w-1/3 flex justify-start lg:justify-end">
            <FooterRight />
          </div>
        </div>
        {/* Copyright Section */}
        <div className="text-xs text-left lg:text-center text-gray-500 mt-8 mb-4">
          <a
            href="https://canguru.com.au"
            target="_blank"
            rel="noopener noreferrer"
          >
            © {new Date().getFullYear()} CanGuru Tech PTY LTD
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
